<template>
    <div class="form_block chart">
        <div class="title">Potential reach:</div>
        <div id="doughnut"></div>
        <div id="alertMessage" class="alert-message" style="display: none;">
            <div class="alert-text">
            Text recommendations to increase the reach of the audience.
            </div>
        </div>
        <div class="desc">
            <div>
                Estimated number of users you will reach daily
            </div>
            <div class="ul-cont">
                Dependencies:
                <ul>
                    <li>
                        Campaign type
                    </li>
                    <li>
                        Targeting
                    </li>
                    <li>
                        Budget
                    </li>
                    <li>
                        Rates
                    </li>
                </ul>
            </div>
            <div>
                Your actual reach may vary
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapMutations, mapActions } from 'vuex';

    export default {
        components: {},
        props: {},
        data() {
            return {
                entries: 16,
                deg: 1,
                colors: ["#3caf7e", "#57b46b", "#73b756", "#91b840",
                         "#b0b829", "#d1b411", "#f4ae07", "#f4a510",
                         "#f49c17", "#f3931d", "#f18a23", "#f07c28",
                         "#ee6c2b", "#ec5c2e", "#ea4930", "#e73232"],
                val: 6000000,
                max: 8000000,
                counter: 0,
                _timerId: null,
            }
        },
        computed: {
        },
        mounted() {
            this.$root.$on('calcChartRates', this.getChartRates);
            // this.counter = (100 - ((100 / this.max) * this.val)) / 6.25;
            // const campaignObj = this.getCampaignPotentialData();
            // this.getCampaignRates(campaignObj)
            //    .then((data) => {
            //        this.calcChartRates(data);
            //    });
        },
        methods: {
            ...mapActions(
                [
                    'getCampaignRates',
                ]
            ),

            bindDoughnut() {
                const MIL = 1000000;
                let stickyCont = document.getElementById('doughnut');

                // if (this.counter < 11) {
                //     document.getElementById('alertMessage').style.display = "none";
                // } else {
                //     document.getElementById('alertMessage').style.display = "flex";
                // }

                document.getElementById('alertMessage').style.display = "none";

                const cont = document.createElement('div');
                cont.classList.add('doughnut-cont');
                for (let i = 0; i < this.entries; i++) {
                    const doughnut = document.createElement('div');
                    doughnut.classList.add('doughnut');
                    const doughnutInner = document.createElement('div');
                    doughnutInner.classList.add('doughnut-inner');
                    if (i >= this.counter || i === this.entries - 1) {
                        doughnutInner.style.backgroundColor = this.colors[i];
                    }
                    doughnut.appendChild(doughnutInner);
                    doughnut.style.transform = 'rotate(' + this.deg + 'deg)';
                    cont.appendChild(doughnut);
                    this.deg = this.deg + 22.5;
                };
                const inside = document.createElement('div');
                const insideMin = document.createElement('div');
                const insideOfMax = document.createElement('div');
                inside.classList.add('inside');
                insideMin.innerHTML = parseInt(this.val / MIL) + 'M';
                insideMin.style.color = this.colors[this.counter];
                insideOfMax.innerHTML = 'of ' + parseInt(this.max / MIL) + 'M';
                insideOfMax.style.fontSize = 14 + 'px';
                inside.appendChild(insideMin);
                if (this.val < this.max) {
                    inside.appendChild(insideOfMax);
                }
                cont.appendChild(inside);
                stickyCont.appendChild(cont);
            },

            calcChartRates({ count, maxCount }) {
                this.val = count;
                this.max = maxCount;
                this.counter = (100 - ((100 / this.max) * this.val)) / 6.25;
                const removeChart = document.querySelector('#doughnut .doughnut-cont');
                if (removeChart) { removeChart.remove();}
                this.bindDoughnut();
            },

            getChartRates() {
                if (model.currentCampaignObj.isOnBoarding) {
                    if (this._timerId != null)
                        clearTimeout(this._timerId);
                        this._timerId = setTimeout(() => {
                            //  send request
                            const campaignObj = this.getCampaignPotentialData();
                            this.getCampaignRates(campaignObj)
                                .then((data) => {
                                    this.calcChartRates(data);
                                });
                        }, 500);
                }
            },

            getCampaignPotentialData() {
                var isOnBoarding = model.currentCampaignObj.isOnBoarding;
                var brands = model.currentCampaignObj.brands_audience_to_save.inc.split(',').filter(x => x.indexOf("Brand:") > -1).map(x => x.substring(6)).join(',');
                var isDirectBy = model.currentCampaignObj.target_type == 2;
                var inc = model.selected_locations.include.flatMap(c => c.country_code != "" ? [c.continent_code + "_" + c.country_code + "__"] : model.countries_locations.filter(x => x.continent_code == c.continent_code && model.selected_locations.exclude.map(c => c.continent_code + "_" + c.country_code + "__").indexOf(x.id) < 0).map(d => d.continent_code + "_" + d.country_code + "__"));
                var country = inc.filter((item, index) => inc.indexOf(item) === index).map(d => d.split('_')[1]).join(',');
                var languages = model.currentCampaignObj.campaignLangs || "";
                var targetAppsList = isDirectBy ? (model.currentCampaignObj.target_apps_list || "") : "";
                model.selected_os_min_version = model.selected_os_min_version ? model.selected_os_min_version.length ? model.selected_os_min_version : [model.selected_os_min_version] : [{}];
                var osVersions = model.currentCampaignObj.userAgentsOSType == 1 ? model.userAgentOSs[model.camp_platform_id].filter(x => x && x.order_by >= model.selected_os_min_version[0].order_by).map(o => o.user_agent_os_id).join(',') : model.currentCampaignObj.userAgentsOSList;
                return { isOnBoarding, isDirectBy, targetAppsList, brands, country, languages, osVersions };
            }
        }
    }

</script>

<style lang="scss">
    #stickyDoughnut {
        position: sticky;
        top: 1px;
        float: left;
        height: 0;
        margin-left: 890px;
    }

        #stickyDoughnut .form_block.chart {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

            #stickyDoughnut .form_block.chart .ul-cont {
                margin: 15px 0;
            }

                #stickyDoughnut .form_block.chart .ul-cont ul {
                    padding-inline-start: 40px;
                }

        #stickyDoughnut .title {
            font-size: 15px;
            font-weight: 700;
            margin-bottom: 15px;
        }

        #stickyDoughnut .desc {
            margin-top: 15px;
            font-size: 12px;
            line-height: 14px;
            color: #818181;
            max-width: 170px;
        }

        #stickyDoughnut .alert-message {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 8px;
            width: 170px;
            background: #FFF1EA;
            border: 1px solid #FFDECE;
            border-radius: 4px;
            margin: 10px 0px;
        }

            #stickyDoughnut .alert-message .alert-text {
                font-size: 12px;
                line-height: 14px;
                color: #8A3838;
            }

    .doughnut-cont {
        position: relative;
        border: 1px solid lightgray;
        border-radius: 50%;
        width: 144px;
        height: 144px;
    }

    .inside {
        content: '';
        width: 100px;
        height: 100px;
        position: absolute;
        background: white;
        z-index: 1000;
        border-radius: 50%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #6B6B6B;
        font-weight: bold;
    }

    .doughnut {
        position: absolute;
        width: 140px;
        height: 140px;
        overflow: hidden;
        left: 72px;
        top: 2px;
        -moz-transform-origin: left center;
        -ms-transform-origin: left center;
        -o-transform-origin: left center;
        -webkit-transform-origin: left center;
        transform-origin: left center;
    }

    .doughnut-inner {
        content: "";
        position: absolute;
        width: 70px;
        height: 140px;
        left: -70px;
        border-radius: 70px 0 0 70px;
        -moz-transform-origin: right center;
        -ms-transform-origin: right center;
        -o-transform-origin: right center;
        -webkit-transform-origin: right center;
        transform-origin: right center;
        background-color: lightgray;
        transform: rotate(21.5deg);
    }

</style>



// WEBPACK FOOTER //
// src/components/Common/StickyDoughnut/StickyDoughnut.vue